<script lang="ts">
  const today = new Date();
  const year = today.getFullYear();

  // Add new events here and the "is" object will
  // magically turn it into a predicate.
  // keep in mind:
  //  start is includisve, end is exclusive
  //  months are 0-indexed
  const schedule = {
    halloween: { start: new Date(year, 9, 25), end: new Date(year, 9, 25) },
    christmas: {
      start: new Date(year, 11, 1),
      end: new Date(year, 12, 30),
    },
    aprilFools: { start: new Date(year, 3, 1), end: new Date(year, 3, 1) },
  };

  // Bellow is magic typescript stuff,
  // just use "is.eventName" in the render function
  type EventName = keyof (typeof schedule);
  type EventSchedule = {
    [E in EventName]: boolean;
  };
  const is: EventSchedule = Object.entries(schedule)
    .map<[EventName, boolean]>((
      entry: [string, { start: Date; end: Date }],
    ) => [
      entry[0] as EventName,
      entry[1].start <= today && today < entry[1].end,
    ])
    .reduce((prev, cur) => ({
      ...prev,
      [cur[0]]: cur[1],
    }), {} as Partial<EventSchedule>) as EventSchedule;
</script>

<!-- Logo -->
<div class="py-4 w-20 min-width-20">
  <a href="#/">
    {#if is.halloween}
      <img
        class="logo-min-width-80"
        src="/graphics/logo-halloween.png"
        alt="Parkando logo"
      />
    {:else}
      <img
        class="invert logo-min-width-80"
        src="/graphics/logo.svg"
        alt="Parkando logo"
      />
    {/if}
  </a>
</div>
<style>
  .logo-min-width-80 {
    min-width: 80px;
  }
</style>
